import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import { Container, Tab, Tabs, Typography } from '@mui/material';

import { GET_CUSTOMER, PETOLO_REFERRAL_INFO_LINK } from '../../../../shared';

import PetoloReferralInformation from './PetoloReferralInformation';
import PetoloReferralStatus from './PetoloReferralStatus';
import { PageTitle } from '../../../../components/common';

function PetoloReferral() {
  const { data: customerData, loading: customerLoading } = useQuery(GET_CUSTOMER);
  const { uuid } = customerData?.customer || {};

  const [selectedTabIdx, setSelectedTabIdx] = useState(0);

  const handleSelectTab = (event, index) => {
    event.persist();
    setSelectedTabIdx(index);
  };

  const handleGoToReferralInfoLink = () => {
    let referralInfoLink = PETOLO_REFERRAL_INFO_LINK;

    if (uuid) {
      referralInfoLink = `${PETOLO_REFERRAL_INFO_LINK}?uuid=${uuid}`;
    }

    window.open(referralInfoLink, '_blank');
  };

  return (
    <Container>
      <PageTitle data-testid="pagename_referral_petolo">
        <Typography variant="h1">
          <FormattedMessage
            id="referral.page.petolo.title"
            values={{ amount: 50, couponbrand: 'Fressnapf-Gutschein' }}
          />
        </Typography>
      </PageTitle>

      <Tabs value={selectedTabIdx} aria-label="referral details" onChange={handleSelectTab}>
        <Tab
          label={
            <Typography variant={selectedTabIdx === 0 ? 'h3' : 'p'}>
              <FormattedMessage id="referral.page.tab.label.one" />
            </Typography>
          }
          id="referral_information_tab"
          aria-controls="referral_information_tabpanel"
        />

        <Tab
          label={
            <Typography variant={selectedTabIdx === 1 ? 'h3' : 'p'}>
              <FormattedMessage id="referral.page.tab.label.two" />
            </Typography>
          }
          id="referral_status_tab"
          aria-controls="referral_status_tabpanel"
        />
      </Tabs>

      <div
        role="tabpanel"
        hidden={selectedTabIdx !== 0}
        id="referral_information_tabpanel"
        aria-labelledby="referral_information_tab"
      >
        <PetoloReferralInformation
          customer={customerData?.customer}
          customerLoading={customerLoading}
          onReferralInfoLinkClick={handleGoToReferralInfoLink}
        />
      </div>

      <div
        role="tabpanel"
        hidden={selectedTabIdx !== 1}
        id="referral_status_tabpanel"
        aria-labelledby="referral_status_tab"
      >
        <PetoloReferralStatus onReferralInfoLinkClick={handleGoToReferralInfoLink} />
      </div>
    </Container>
  );
}

export default PetoloReferral;
